(() => {
  const INGRESS_SEARCH_SELECTOR = '.bm-collection-ingress-search__button';

  function findHeaderSearchTrigger(trigger) {
    const headerRoot = document.querySelector('.bm-header-1');

    if (!headerRoot) return null;

    const candidates = headerRoot.querySelectorAll('button, a, summary');

    return Array.from(candidates).find((candidate) => {
      if (candidate === trigger) return false;

      return candidate.getAttribute('on:click') === '#search-modal/showDialog';
    }) || null;
  }

  function clickLikeUser(element) {
    element.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
  }

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest(INGRESS_SEARCH_SELECTOR);

      if (!trigger) return;

      const headerSearchTrigger = findHeaderSearchTrigger(trigger);

      if (!headerSearchTrigger) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      clickLikeUser(headerSearchTrigger);
    },
    true
  );
})();
